export default {
  description: 'BTC PROP, poslovna enota družbe BTC, svojim poslovnim partnerjem zagotavlja prvovrstne storitve upravljanja portfelja nepremičnin. BTC PROP je vodilni ponudnik tovrstnih storitev na slovenskem trgu, ki upravlja skupaj več kot 600.000 m2 površin, ter izvaja tudi storitve vzdrževanja in svetovanja.',
  title: 'BTC Nepremičnine',
}